document.addEventListener("DOMContentLoaded", function(){

function getWishlist(){
return JSON.parse(localStorage.getItem("wishlist")) || [];
}

function updateWishlistCount(){

let wishlist = getWishlist();
let count = document.getElementById("wishlist-count");

if(count){
count.innerText = wishlist.length;
}

}

function checkWishlistState(){

let wishlist = getWishlist();

document.querySelectorAll(".wishlist-btn").forEach(btn=>{

let id = btn.dataset.productId;

let exists = wishlist.find(item => item.id == id);

if(exists){
btn.classList.add("active");
}else{
btn.classList.remove("active");
}

});

}

document.addEventListener("click", function(e){

let btn = e.target.closest(".wishlist-btn");

if(!btn) return;

let product = {
id: btn.dataset.productId,
handle: btn.dataset.handle,
title: btn.dataset.title,
image: btn.dataset.image,
price: btn.dataset.price
};

let wishlist = getWishlist();

let index = wishlist.findIndex(item => item.id == product.id);

if(index === -1){

  wishlist.push(product);
  btn.classList.add("active");

  // ✅ ADD event - GA4
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'add_to_wishlist',
    ecommerce: {
      items: [{ item_id: product.id, item_name: product.title, price: parseFloat(product.price)/100 }]
    }
  });

}else{

  wishlist.splice(index,1);
  btn.classList.remove("active");

  // ✅ REMOVE event - GA4
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'remove_from_wishlist',
    ecommerce: {
      items: [{ item_id: product.id, item_name: product.title, price: parseFloat(product.price)/100 }]
    }
  });

}


localStorage.setItem("wishlist", JSON.stringify(wishlist));

updateWishlistCount();

});

updateWishlistCount();
checkWishlistState();

});

window.addEventListener('scroll', function() {
  var scrollToTopButton = document.getElementById('scrollToTop');

  if (window.scrollY > 100) {
    scrollToTopButton.style.display = 'block'; // Show the button when the page is scrolled down
  } else {
    scrollToTopButton.style.display = 'none'; // Hide the button when the page is at the top
  }
});

document.getElementById('scrollToTop').addEventListener('click', function() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // Smooth scrolling animation
  });
});